<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        :placeholder="$t('station.stationName')"
        v-model="listQuery.title"
        style="width: 200px;"
        class="filter-item"
      />
      <el-button
        v-waves
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        style="margin-left: 20px"
        @click="handleFilter"
      >{{ $t('table.search') }}</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :key="tableKey"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;">
      <el-table-column :label="$t('station.stationId')" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.stationId }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('station.stationName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.stationName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('station.contactName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.contactName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('station.contactPhone')" align="center" width="140px">
        <template slot-scope="scope">
          <span>{{ scope.row.contactPhone }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('grade.status')" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.isActivated | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('station.activationTime')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.activationTime }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { stationList } from '@/api/station'
import waves from '@/directive/waves' // 水波纹指令

const statusMap = { 0: '已停用', 1: '启用中' }
export default {
  name: 'List',
  directives: {
    waves
  },
  filters: {
    statusFilter (status) {
      return statusMap[status]
    },
    typeFilter (type) {
    }
  },
  data () {
    return {
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        status: '',
        title: ''
      },
      rules: {
        creditAmt: [{ required: true, message: '必须填写', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.listLoading = true
      this.listQuery['pi'] = this.listQuery.page
      this.listQuery['ps'] = this.listQuery.limit
      this.listQuery['stationName'] = this.listQuery.title
      stationList(this.listQuery).then(response => {
        const row = response.data
        if (row.data) {
          this.list = row.data.items
          this.total = row.data.totalItems
        }
        this.listLoading = false
      })
    },
    handleFilter () {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.listQuery.page = val
      this.getList()
    }
  }
}
</script>
